'use strict';

import jQuery from 'jquery';
import ga from './../../vendor/google-analytics';
import heroSlider from './../HeroSlider/heroSlider';

/**
 * Homepage
 *
 * JavaScript functions for the homepage
 */
var Homepage = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create references to the sets of blog posts
      privateNS.$blogPostSets = privateNS.$container.find('.hero-blog-posts');

      // Create a reference to the blog post set toggle control
      privateNS.$blogPostToggle = privateNS.$container.find('.hero-blog-loadmore');

      // Create a reference to the display element for the blog post set toggle control
      privateNS.$blogPostToggleDisplay = privateNS.$blogPostToggle.find('.toggle');

      heroSlider({
        container: '.main-hero'
      });

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Given a current set index and the number of sets to cycle through,
     * computes the index of the set to show
     *
     * @param currentIndex int The current blog post set
     * @param numberOfSets int The total number of blog post sets
     *
     * @returns int The index of the blog post set to show
     */
    privateNS.getNextBlogPostSetIndex = function getNextBlogPostSetIndex(currentIndex, numberOfSets) {

      // Calculate the next set to display by trying to move the next set (+ 1)
      // and then wrapping around to 0 if the next set is beyond the maximum
      // number of sets (% numberOfSets)
      return (currentIndex + 1) % numberOfSets;
    };

    /**
     * Retrieve the current blog set from DOM, transition to displaying
     * the next blog set in the list, update the state of the blog set
     * control, and finally update the DOM with the new index
     *
     * @param event The triggering event
     */
    privateNS.cycleBlogPostSets = function cycleBlogPostSets(event) {

      // Retrieve the current state of the blog post sets, and cast as a number
      var currentSet = privateNS.$blogPostToggle.attr('data-state')| 0,
        setToShow = privateNS.getNextBlogPostSetIndex(currentSet, privateNS.$blogPostSets.length);

      // Hide all of the blog post sets before showing the new one
      privateNS.$blogPostSets.addClass('hide');

      // Show the next set in the list
      privateNS.$blogPostSets.eq(setToShow).removeClass('hide');

      // Toggle the display of the control to match the state
      privateNS.$blogPostToggleDisplay.toggleClass('toggle-bottom');

      // Update the state of the toggle control
      privateNS.$blogPostToggle.attr('data-state', setToShow);
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function() {

      // Bind the blog post list toggle control
      privateNS.$blogPostToggle.on(
        'click',
        privateNS.cycleBlogPostSets
      );

      $('.hero-action, .hero-post').each(function(i, el) {
        var $el = $(el);

        $el.click(function(e) {
          ga('send', 'event', 'homepage', $el.attr('id'), $el.attr('href'));
        });
      });

      $('.homepage-link-target').each(function(i, el) {
        var $el = $(el);

        $el.click(function(e) {
          ga('send', 'event', 'homepage', 'Click Main Button', $el.attr('href'));
        });
      });
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default Homepage